var React = require('react');

function IconCaretDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1"},React.createElement("g",{"fill":"#142B6F","fillRule":"nonzero"},React.createElement("g",null,React.createElement("g",{"transform":"translate(-304.000000, -285.000000) translate(135.000000, 160.000000) translate(0.000000, 118.000000)"},React.createElement("polygon",{"points":"180.205 12 173 4.462 174.397 3 183 12 174.397 21 173 19.538","transform":"translate(178.000000, 12.000000) rotate(90.000000) translate(-178.000000, -12.000000)"}))))));
}

IconCaretDown.defaultProps = {"width":"18","height":"10","version":"1.1","viewBox":"0 0 18 10"};

module.exports = IconCaretDown;

IconCaretDown.default = IconCaretDown;
